/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

if (document.getElementById("personalization-text") != null ) {
  document.addEventListener('product:added', function(event) {
    var variant = event.detail.variant;
    var personalization = event.detail.personalization;
    if (variant && personalization == true && variant.id != 31797670215759 ) {
      fetch(window.theme.localeRootUrl + '/cart/add.js', {
        body: JSON.stringify (
          {
            'id': 31797670215759,
            'quantity': 1,
            'properties': {
              'Note': 'Removing this impacts your products personalization.'
            }
          }
        ),
        credentials: 'same-origin',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      }).then(function(event) {
        document.documentElement.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: {
            'quantity': 1
          }
        }));
      });
    };
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true
    }));
  });
};

if (document.getElementById("personalization-text") != null ) {
  var input = document.getElementById('personalization-text');
  var font = document.getElementById('personalization-font');
  var log = document.getElementById('personalization-display');
  
  if (log == null) {
    var log = document.getElementById('personalization-display');
  };
  
  input.oninput = handleTextInput;
  font.oninput = handleFontInput;

  function handleTextInput(e) {
    if (e.target.value) {
      log.innerHTML = e.target.value;
    } else {
      log.innerHTML = "Your Personalization Text is Displayed Here";
    }
  }
  function handleFontInput(e) {
    log.style.fontFamily = e.target.value;
  }
};


if (document.getElementById("personalization-option") != null ) {
  document.getElementById('personalization-option').addEventListener("click", personalizationBuyOption);
  function personalizationBuyOption() {
    if(document.getElementById('personalization-option').checked == true) {
      document.getElementById("personalization-payment-button").style.display = 'none';
    } else {
      document.getElementById("personalization-payment-button").style.display = 'block';
    }
  }
};

if (document.getElementById("slideshow-div") != null ) {
  var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
  if (width > 1800 ) {
    document.getElementById("slideshow-div").style.height = '900px';
  }
}

/*
function cart_personalization_check() {
  fetch(window.theme.localeRootUrl + '/cart', {
    credentials: 'same-origin',
    method: 'GET'
  }).then(function (response) {
    document.dispatchEvent(new CustomEvent('theme:loading:end'));
    response.json().then(function (result) {
      items = result.items;
    });
  });
};
*/

document.addEventListener('product:added', function(event) {
  pintrk('track', 'addtocart');
});